/**
 * Maps a Starlink/Clarus service-line subscription description (a billing SKU
 * such as `gb-enterprise-pool-global-priority-terminal-access-fee-usd`) to a
 * short, user-facing scope label.
 *
 * The SKU is free-form text from Clarus; only the scope (`global` / `local` /
 * `mobile`) and tier (`priority`) tokens carry display meaning, so matching is
 * by substring and ignores the region, pooling, line-item and currency segments
 * — these vary independently (e.g. `it-enterprise-global-priority-…` has no
 * `pool`). Returns null when no known scope is present, so callers can fall back.
 */
export const priorityScope = (description: string | null | undefined): string | null => {
  if (!description) return null;
  const s = description.toLowerCase();
  if (s.includes('global') && s.includes('priority')) return 'Global priority';
  if (s.includes('local') && s.includes('priority')) return 'Local priority';
  if (s.includes('mobile') && s.includes('priority')) return 'Mobile priority';
  if (s.includes('priority')) return 'Priority';
  return null;
};
